<template>
  <vjs-modal name="update-stream-modal"
             icon="la la-edit"
             title="Update Stream">
    <template slot="body-content">
      <div class="form-group kt-form__group">
        <label for="name">Old name</label>
        <multiselect
          v-model="selected_stream"
          :allow-empty="false"
          label="name"
          :options="streams"
          track-by="name"
          placeholder="Select a stream to update..."
          @input="fillForm" />
        <br>
        <label for="name">New name</label>
        <input id="name"
               v-model="name"
               class="form-control"
               type="text">
        <br>
        <label for="server">Server</label>
        <input id="server"
               v-model="server"
               class="form-control"
               type="text">
      </div>
      <div class="form-group kt-form__group">
        <label for="format">Format:&nbsp;&nbsp;</label>
        <p-radio v-model="format"
                 class="p-default p-round"
                 name="format"
                 value="mp3">
          mp3
        </p-radio>
        <p-radio v-model="format"
                 class="p-default p-round"
                 name="format"
                 value="aac">
          aac
        </p-radio>
      </div>
    </template>
    <template slot="body-controls">
      <button class="btn btn-ss-standout"
              @click="streamPatch">
        <span>
          <i class="la la-save" />
          <span>Update</span>
        </span>
      </button>
      <button type="button"
              class="btn btn-ss-cancel"
              @click="closeModal">
        Cancel
      </button>
    </template>
  </vjs-modal>
</template>

<script>
import PrettyRadio from "pretty-checkbox-vue/radio";
import VjsModal from "VueModals/VjsModal";
Vue.component("p-radio", PrettyRadio);

export default {
  components: {
    VjsModal,
  },
  props: {
    streams: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    selected_stream: {},
    name: "",
    server: "",
    format: "",
  }),
  methods: {
    fillForm() {
      this.name = this.selected_stream.name;
      this.server = this.selected_stream.server;
      this.format = this.selected_stream.format;
    },

    streamPatch() {
      if (this.name === "") {
        toastr.error("Name cannot be empty!");
      } else {
        if (_.includes(["mp3", "aac"], this.format)) {
          this.$emit('input', {
            old_name: this.selected_stream.name,
            name: this.name,
            format: this.format,
            server: this.server,
          });

          this.name = "";
          this.server = "";
          this.format = "";
          this.selected_stream = null;
          this.closeModal();
        } else {
          toastr.error("Format is not supported!");
        }
      }
    },
    closeModal() {
      this.$modal.hide(`update-stream-modal`);
    },
  },
};
</script>

<style lang='scss'>
@import "~pretty-checkbox/src/scss/variables";
@import "~pretty-checkbox/src/scss/core";
@import "~pretty-checkbox/src/scss/elements/default/outline";
@import "~pretty-checkbox/src/scss/extras/round";
</style>
